import React, { useEffect, useState } from 'react';
import { apiPost } from '../../utils/api';
import './RetireHealthPanel.css';

// 퇴사자 건강보험 정산: 퇴사자 한 명씩, 퇴직한 해(1~3월 퇴직이면 전년도까지)의 확정보험료를 다시 계산해
// 그동안 급여에서 뗀 보험료와의 차액을 보여 준다. [추가하기]를 누르면 그 차액을 공제항목 '건강보험 퇴직정산'에 넣는다.
// 계산은 모두 서버가 한다(근무월수·정산월수를 고치면 다시 불러온다).

// 개발 중: 계산 숫자가 아직 확인되지 않았다. 켜 두는 동안은 보기만 하고 대장에 넣지는 못한다.
// 숫자가 확인되면 false 로 바꾼다(단추의 '개발 중' 표시는 Payroll.js 의 같은 이름 상수).
export const RETIRE_HEALTH_IN_DEVELOPMENT = true;

const won = (v) => Math.round(v).toLocaleString('ko-KR');
const signed = (v) => `${v > 0 ? '+' : ''}${won(v)}`;
const percent = (v) => (v == null ? '값 없음' : `${String(Math.round(Number(v) * 1e8) / 1e6)}%`);
const count = (v) => String(Math.round(v * 100) / 100);
const day = (text) => String(text || '').slice(5);

function YearBlock({ block, counts, onCount }) {
  const mine = counts[block.year] || {};
  const field = (key, value, fallback) => (
    <span className="pr-rh-count">
      <input
        type="number"
        min="0"
        step="1"
        className={mine[key] != null ? 'edited' : ''}
        value={mine[key] != null ? mine[key] : value}
        onChange={(e) => onCount(block.year, key, e.target.value)}
        onKeyDown={(e) => e.stopPropagation()}
      />
      {mine[key] != null && (
        <button type="button" className="pr-rh-link" onClick={() => onCount(block.year, key, '')} title={`기본값 ${count(fallback)}개월로 되돌립니다`}>기본 {count(fallback)}</button>
      )}
    </span>
  );

  return (
    <section className="pr-rh-year">
      <h4>
        {block.year}년
        <span>건강보험 {percent(block.health_rate)} · 장기요양 {percent(block.care_rate)} <em>({block.rate_month}월 요율)</em></span>
        {block.rate_changed && <b className="warn">해 가운데 요율이 바뀌었습니다. 마지막 달 요율로 계산했습니다.</b>}
      </h4>

      <table className="pr-rh-months">
        <thead>
          <tr><th>월</th><th>보수월액</th><th>건강보험</th><th>장기요양</th><th>적용 요율</th><th>비고</th></tr>
        </thead>
        <tbody>
          {block.months.map((m) => {
            const flagOf = (key) => m.flags.filter((f) => f.key === key || (key === 'd.건강보험' && (f.key === 'ins.health' || f.key === 'health_base')));
            const health = flagOf('d.건강보험');
            const care = flagOf('d.요양보험');
            return (
              <tr key={m.month} className={m.exists ? '' : 'missing'}>
                <td>{m.month}월</td>
                <td className="num">{m.exists ? won(m.pay) : '–'}</td>
                <td className={`num ${health.length ? 'over' : ''}`} title={health.map((f) => f.text).join('\n')}>{m.exists ? won(m.health) : '–'}</td>
                <td className={`num ${care.length ? 'over' : ''}`} title={care.map((f) => f.text).join('\n')}>{m.exists ? won(m.care) : '–'}</td>
                <td className="rate">{percent(m.health_rate)} · {percent(m.care_rate)}</td>
                <td className="note">
                  {m.note && <span className="warn">{m.note}</span>}
                  {m.flags.map((f) => <span key={`${f.key}-${f.type}`} className="over-tag" title={f.text}>{f.type === 'override' ? '직접 넣은 값' : f.type === 'forced' ? '미적용 지정' : '고지금액 기준'}</span>)}
                  {m.leaves.map((x) => <span key={`${x.start}-${x.end}`} className="leave-tag" title={`${x.reason || '휴직'} ${x.start} ~ ${x.end || ''}`}>{x.reason || '휴직'} {day(x.start)}~{day(x.end)}</span>)}
                </td>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr><td>합계</td><td className="num">{won(block.total_pay)}</td><td className="num">{won(block.paid_health)}</td><td className="num">{won(block.paid_care)}</td><td /><td /></tr>
        </tfoot>
      </table>

      <div className="pr-rh-counts">
        <label title="(월평균)보수월액 = 보수총액 ÷ 근무월수. 기본값은 보수가 있는 달 수입니다">근무월수 {field('work', block.work_months, block.work_default)}</label>
        <label title="확정보험료 = 월 보험료 × 정산월수. 기본값은 건강보험료를 뗀 달 수입니다">정산월수 {field('settle', block.settle_months, block.settle_default)}</label>
        <span className="pr-rh-muted">기본값: 근무월수 = 보수가 있는 달 수, 정산월수 = 건강보험료를 뗀 달 수</span>
      </div>

      <table className="pr-rh-calc">
        <thead>
          <tr><th /><th>건강보험</th><th>장기요양</th><th>계산</th></tr>
        </thead>
        <tbody>
          <tr>
            <td>(월평균)보수월액</td>
            <td className="num" colSpan={2}>{won(block.base_pay)}</td>
            <td className="how">보수총액 {won(block.total_pay)} ÷ 근무월수 {count(block.work_months)}{block.capped && ` = ${won(block.average_pay)} → 상·하한 적용`}</td>
          </tr>
          <tr>
            <td>월 보험료</td>
            <td className="num">{won(block.monthly_health)}</td>
            <td className="num">{won(block.monthly_care)}</td>
            <td className="how">보수월액 × {percent(block.health_rate)} / 월 건강보험료 × {percent(block.care_rate)} (10원 미만 버림)</td>
          </tr>
          <tr>
            <td>① 확정보험료</td>
            <td className="num">{won(block.final_health)}</td>
            <td className="num">{won(block.final_care)}</td>
            <td className="how">월 보험료 × 정산월수 {count(block.settle_months)}</td>
          </tr>
          <tr>
            <td>② 기부과 보험료</td>
            <td className="num">{won(block.paid_health)}</td>
            <td className="num">{won(block.paid_care)}</td>
            <td className="how">매월 급여에서 뗀 보험료의 합</td>
          </tr>
          <tr className="result">
            <td>③ 정산보험료 (① − ②)</td>
            <td className="num">{signed(block.diff_health)}</td>
            <td className="num">{signed(block.diff_care)}</td>
            <td className="how">합계 <b>{signed(block.diff)}</b></td>
          </tr>
        </tbody>
      </table>
    </section>
  );
}

function RetireHealthPanel({ base, retirees, initialRowId, onApplied, onClose }) {
  const [rowId, setRowId] = useState(retirees.some((r) => r.id === initialRowId) ? initialRowId : retirees[0].id);
  const [counts, setCounts] = useState({});      // {연도: {work, settle}} — 직접 고친 값만
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const index = retirees.findIndex((r) => r.id === rowId);
  const countsJson = JSON.stringify(counts);

  useEffect(() => {
    let cancelled = false;
    const timer = setTimeout(async () => {
      try {
        const result = await apiPost(`${base}/retire-health`, { row_id: rowId, counts: JSON.parse(countsJson) });
        if (!cancelled) { setData(result); setError(''); }
      } catch (e) {
        if (!cancelled) { setData(null); setError(e.message); }
      }
    }, 250);
    return () => { cancelled = true; clearTimeout(timer); };
  }, [base, rowId, countsJson]);

  const pick = (id) => { setRowId(id); setCounts({}); setData(null); };
  const onCount = (year, key, text) => setCounts((prev) => {
    const next = { ...prev, [year]: { ...(prev[year] || {}) } };
    if (text === '' || Number.isNaN(Number(text)) || Number(text) < 0) delete next[year][key];
    else next[year][key] = Number(text);
    return next;
  });

  const apply = async () => {
    setBusy(true);
    setError('');
    try {
      onApplied(await apiPost(`${base}/retire-health`, { row_id: rowId, counts, apply: true }));
    } catch (e) {
      setError(e.message);
      setBusy(false);
    }
  };

  const total = data && data.total;
  const missing = data ? data.years.flatMap((b) => b.months.filter((m) => !m.exists).map((m) => `${b.year}-${String(m.month).padStart(2, '0')}`)) : [];

  return (
    <div className="pr-rh" onMouseDown={(e) => e.stopPropagation()}>
      <div className="pr-rh-head">
        <b>퇴사자 건강보험 정산{RETIRE_HEALTH_IN_DEVELOPMENT && <span className="pr-rh-dev">개발 중</span>}</b>
        <button type="button" className="pr-rh-close" onClick={onClose} title="닫기">✕</button>
      </div>

      <div className="pr-rh-who">
        <button type="button" className="pr-btn" disabled={index <= 0} onClick={() => pick(retirees[index - 1].id)} title="앞 퇴사자">◀</button>
        <select value={rowId} onChange={(e) => pick(e.target.value)}>
          {retirees.map((r) => <option key={r.id} value={r.id}>{r.values.name || `${r.order}번`} · 퇴사 {r.values.leave_date}</option>)}
        </select>
        <button type="button" className="pr-btn" disabled={index >= retirees.length - 1} onClick={() => pick(retirees[index + 1].id)} title="다음 퇴사자">▶</button>
        <span className="pr-rh-muted">{index + 1} / {retirees.length}명</span>
        {data && (
          <span className="pr-rh-dates">입사 <b>{data.employee.hire_date || '–'}</b> · 퇴사 <b>{data.employee.leave_date}</b></span>
        )}
      </div>

      {RETIRE_HEALTH_IN_DEVELOPMENT && (
        <div className="pr-rh-warn">개발 중인 기능입니다. 계산 숫자가 아직 확인되지 않았으니 참고용으로만 보세요. 확인이 끝날 때까지 [추가하기]는 막아 두었습니다.</div>
      )}
      {error && <div className="pr-rh-error">{error}</div>}
      {!data && !error && <div className="pr-rh-loading">자료를 모으는 중…</div>}

      {data && (
        <>
          {data.previous_year_included && (
            <div className="pr-rh-info">1~3월 퇴직이라 전년도 연말정산이 아직 끝나지 않았습니다. 전년도도 함께 정산합니다.</div>
          )}
          {missing.length > 0 && (
            <div className="pr-rh-warn">자료가 없는 달이 있습니다({missing.join(', ')}). 그 달의 보수와 보험료는 0으로 들어가 있으니, 대장을 먼저 올리거나 근무월수·정산월수를 확인해 주세요.</div>
          )}
          {data.years.length === 0 && <div className="pr-rh-warn">정산할 달이 없습니다. 입사일과 퇴사일을 확인해 주세요.</div>}
          {data.years.map((block) => <YearBlock key={block.year} block={block} counts={counts} onCount={onCount} />)}

          <table className="pr-rh-calc total">
            <thead>
              <tr><th>{data.years.length > 1 ? '전체 합계' : '합계'}</th><th>건강보험</th><th>장기요양</th><th>계</th></tr>
            </thead>
            <tbody>
              <tr><td>① 확정보험료</td><td className="num">{won(total.final_health)}</td><td className="num">{won(total.final_care)}</td><td className="num">{won(total.final_health + total.final_care)}</td></tr>
              <tr><td>② 기존 납부액</td><td className="num">{won(total.paid_health)}</td><td className="num">{won(total.paid_care)}</td><td className="num">{won(total.paid_health + total.paid_care)}</td></tr>
              <tr className="result"><td>③ 차액 (정산보험료)</td><td className="num">{signed(total.diff_health)}</td><td className="num">{signed(total.diff_care)}</td><td className="num">{signed(total.diff)}</td></tr>
            </tbody>
          </table>
          <div className="pr-rh-verdict">
            {Math.abs(total.diff) < 0.5 ? '더 걷거나 돌려줄 금액이 없습니다.'
              : total.diff > 0 ? <>이번 급여에서 <b>{won(total.diff)}원</b>을 더 공제합니다.</>
                : <>이번 급여에서 <b>{won(-total.diff)}원</b>을 돌려줍니다(공제에 음수로 들어갑니다).</>}
            {data.item.amount != null && <span className="pr-rh-muted"> 지금 「{data.item.name}」 칸에는 {signed(data.item.amount)}원이 들어 있습니다.</span>}
          </div>
        </>
      )}

      <div className="pr-rh-actions">
        <span className="pr-rh-muted">
          {data && (data.item.exists ? `공제항목 「${data.item.name}」의 이 직원 칸에 넣습니다.` : `공제항목 「${data.item.name}」을 이 달 대장에 만들고 이 직원 칸에 넣습니다.`)}
        </span>
        <button type="button" className="pr-btn" onClick={onClose}>닫기</button>
        <button type="button" className="pr-btn primary" disabled={RETIRE_HEALTH_IN_DEVELOPMENT || !data || busy || !data.years.length} onClick={apply} title={RETIRE_HEALTH_IN_DEVELOPMENT ? '개발 중이라 아직 대장에 넣을 수 없습니다' : undefined}>
          {busy ? '넣는 중…' : data ? `추가하기 (${signed(total.diff)}원)` : '추가하기'}
        </button>
      </div>
    </div>
  );
}

export default RetireHealthPanel;
